import { SolutionHistoryServiceMock } from "./solutionHistory.types";

export const mockSolutionHistoryService = (): SolutionHistoryServiceMock => ({
  fetchSolutionFileHistory: jest.fn(),
  downloadSolutionFileHistory: jest.fn(),
});
